import React from 'react'
import { Link } from 'react-router-dom'
import './style.css';
import teacher from "../../img/female-teacher_1f469-200d-1f3eb.png";
import student from "../../img/student_1f9d1-200d-1f393.png"

export default (props) => {
  return (
    <div className="container home">
      <div className="row home-button-container" >
        <div className="col-md-6">
          <Link className="btn btn-lg btn-light youth-button" to="/youth">
            <div className='button-content'>
              <p><img alt='Emoji of a student' style={{"width":"100px", "marginRight": "-5px"}} src={student}/></p> Youth
            </div>
          </Link>
        </div>
        <div className="col-md-6">
          <Link className="btn btn-lg btn-light youth-button" to="/teacher">
            <div className='button-content'>
              <p><img alt='Emoji of a teacher' style={{"width":"100px", "marginRight": "-5px"}} src={teacher}/></p> Teacher
            </div>
          </Link>
        </div>
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Home/index.js